import { ChangeEvent, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { ExUpload } from 'components/buttons/CustomButton';
import { useCommonModal } from 'hooks/useCommonModal';

interface Props {
  btnText?: string; // 버튼 표시 문구 (default : 업로드)
  msgConfirm?: string; // confirm 문구 (문구 있는 경우 파일브라우저 전 confirm 노출)
  onPreCheck?: () => Promise<boolean>; // 호출 전 검사할 항목 있는 경우 추가
  onCallback: (files: FileList | null) => void;
}
const ExcelUploadButton = ({ btnText, msgConfirm, onPreCheck, onCallback }: Props) => {
  const inputRef = useRef<any>();
  const { t } = useTranslation();
  const { openCommonModal } = useCommonModal();
  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    event.stopPropagation();
    if (event.currentTarget.files?.[0]) {
      onCallback(event.currentTarget.files);
      event.currentTarget.value = '';
    }
  };

  const handleClick = async (e) => {
    e.preventDefault();
    e.stopPropagation();

    if (msgConfirm) {
      // [26.01.28] precheck 있는 경우 먼저 확인
      if (onPreCheck) {
        if (!(await onPreCheck())) return;
      }
      openCommonModal({
        modalType: 'confirm',
        content: msgConfirm,
        yesCallback: () => {
          inputRef.current?.click();
        },
      });
    } else {
      if (onPreCheck) {
        if (!(await onPreCheck())) return;
      }

      inputRef.current?.click();
    }
  };

  return (
    <>
      <ExUpload>
        <label onClick={handleClick} htmlFor="uploadFile">
          {btnText ? btnText : t('com.label.업로드', '업로드')}
        </label>
      </ExUpload>
      <input
        ref={inputRef}
        type="file"
        id="uploadFile"
        onChange={handleChange}
        style={{ display: 'none' }}
      />
    </>
  );
};

export default ExcelUploadButton;
